function getState(optionState) {
    localStorage.setItem("taboption",optionState)
   
    return {
        type: "SELECTEDTAB_STATE",
        optionState
    }
}

export const selectedtabAction = (selectedOption) => dispatch => {
    let option = selectedOption;
    dispatch(getState(option))
}


// WEBPACK FOOTER //
// ./src/actions/selectedtabaction.jsx